import { Element } from 'alkali'

class Icon extends Element {
	icon: string
	studyId: string
	created(properties) {
		const toHTML = (icon) => {
			let svg = icon.replace(/><defs.*<\/title>/, 'class="streamline-svg">').replace(/id="Regular"/, '')
			return svg
		}
		if (properties.icon.to)
			properties.innerHTML = properties.icon.to(toHTML)
		else
			properties.innerHTML = toHTML(properties.icon)
	}
}

export default Icon.defineElement('streamline-icon')